/**
 * Tutor permissions form section.
 * Mobile-app flags: add / remove students on sessions.
 */
import * as React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Checkbox } from '@/components/forms/Checkbox';

/** Props for {@link TutorPermissionsSection}. */
interface Props {
  formData: Record<string, any>;
  set: (field: string, value: any) => void;
}

/** Tutor permissions form section. */
export function TutorPermissionsSection({ formData, set }: Readonly<Props>) {
  return (
    <div className="form-section">
      <h4 className="form-section-title">
        <ShieldCheck className="w-4 h-4" />
        Permissions
      </h4>
      <Checkbox
        label="Autoriser ce tuteur à ajouter des élèves à ses séances présentielles"
        checked={formData.canAddStudentsToSession === true}
        onCheckedChange={(checked) => set('canAddStudentsToSession', checked)}
        size="sm"
        helperText="Si activé, ce tuteur pourra ajouter ou créer des élèves depuis l'application mobile sur ses séances présentielles uniquement."
      />
      <Checkbox
        label="Autoriser ce tuteur à retirer des élèves de ses séances présentielles"
        checked={formData.canRemoveStudentsFromSession === true}
        onCheckedChange={(checked) => set('canRemoveStudentsFromSession', checked)}
        size="sm"
        helperText="Si activé, ce tuteur pourra retirer des élèves depuis l'application mobile sur ses séances présentielles uniquement."
      />
    </div>
  );
}
